/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PayerSearchOptions } from './PayerSearchOptions';
import {
    PayerSearchOptionsFromJSON,
    PayerSearchOptionsFromJSONTyped,
    PayerSearchOptionsToJSON,
} from './PayerSearchOptions';

/**
 * 
 * @export
 * @interface GetInovalonPayerSearchOptions200Response
 */
export interface GetInovalonPayerSearchOptions200Response {
    /**
     * 
     * @type {PayerSearchOptions}
     * @memberof GetInovalonPayerSearchOptions200Response
     */
    data?: PayerSearchOptions;
}

/**
 * Check if a given object implements the GetInovalonPayerSearchOptions200Response interface.
 */
export function instanceOfGetInovalonPayerSearchOptions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetInovalonPayerSearchOptions200ResponseFromJSON(json: any): GetInovalonPayerSearchOptions200Response {
    return GetInovalonPayerSearchOptions200ResponseFromJSONTyped(json, false);
}

export function GetInovalonPayerSearchOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInovalonPayerSearchOptions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PayerSearchOptionsFromJSON(json['data']),
    };
}

export function GetInovalonPayerSearchOptions200ResponseToJSON(value?: GetInovalonPayerSearchOptions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PayerSearchOptionsToJSON(value.data),
    };
}

